export default __webpack_public_path__ + "static/media/prescriptions.72645ee4.png";